function makeSectionReorderable(containerId) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error(`Container with id ${containerId} not found.`);
        return;
    }
    let draggedItem = null;
    const draggableForms = container.querySelectorAll('.spv-draggable');
    draggableForms.forEach(draggableForm => {
        draggableForm.addEventListener('dragstart', function () {
            draggedItem = draggableForm;
            draggableForm.classList.add('spv-dragging');
        });
        draggableForm.addEventListener('dragend', async function () {
            if (draggedItem) {
                draggedItem.classList.remove('spv-dragging');
                draggedItem = null;
                await updateAndSubmitOrder(container);
            }
        });
        const checkbox = draggableForm.querySelector('input[name="SegmentShow"]');
        if (checkbox) {
            checkbox.addEventListener('change', async function () {
                await updateAndSubmitShowElementForm(draggableForm);
            });
        }
    });
    container.addEventListener('dragover', (e) => {
        e.preventDefault();
        if (!draggedItem)
            return;
        const afterElement = getDragAfterElement(container, e.clientY);
        if (afterElement === null) {
            container.appendChild(draggedItem);
        }
        else {
            container.insertBefore(draggedItem, afterElement);
        }
    });
    function getDragAfterElement(container, y) {
        const remainingDraggableElements = [
            ...container.querySelectorAll('.spv-draggable:not(.dragging)'),
        ];
        return remainingDraggableElements.reduce((closest, child) => {
            const box = child.getBoundingClientRect();
            const offset = y - box.top - box.height / 3;
            if (offset < 0 && offset > closest.offset) {
                return { offset: offset, element: child };
            }
            else {
                return closest;
            }
        }, { offset: Number.NEGATIVE_INFINITY, element: null }).element;
    }
    async function updateAndSubmitOrder(container) {
        const draggableFormItems = Array.from(container.querySelectorAll('.spv-draggable'));
        let endpoint = '';
        let method = '';
        const updatedOrderData = draggableFormItems
            .map((draggableForm, index) => {
            if (index === 0) {
                endpoint = draggableForm.action;
                method = draggableForm.method;
            }
            const segmentName = draggableForm.name;
            const segmentReferenceName = draggableForm.querySelector('input[name="SegmentReference"]');
            const segmentId = draggableForm.querySelector('input[name="SegmentId"]');
            const segmentActive = draggableForm.querySelector('input[name="SegmentShow"]');
            const segmentOrder = draggableForm.querySelector('input[name="SegmentOrder"]');
            if (!segmentId || !segmentActive || !segmentOrder) {
                console.error('Form inputs missing');
                return null;
            }
            segmentOrder.value = (index + 1).toString();
            return {
                referenceName: segmentName,
                id: segmentId.value,
                referenceType: segmentReferenceName?.value,
                active: segmentActive.checked,
                order: index + 1,
            };
        })
            .filter(Boolean);
        try {
            const response = await fetch(endpoint, {
                method: method || 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedOrderData),
            });
            if (response.ok) {
                console.log('Updated order submitted successfully');
            }
            else {
                console.warn('Failed to submit updated order');
            }
        }
        catch (e) {
            console.error('Error submitting order: ', e);
        }
    }
    async function updateAndSubmitShowElementForm(draggableForm) {
        const endpoint = draggableForm.action;
        const method = draggableForm.method;
        const spinner = draggableForm.querySelector('.spv-spinner');
        spinner.setAttribute('aria-live', 'polite');
        spinner.classList.remove('spv-spinner--done');
        spinner.classList.add('spv-spinner--active');
        const segmentName = draggableForm.name;
        const segmentReferenceName = draggableForm.querySelector('input[name="SegmentReference"]');
        const segmentId = draggableForm.querySelector('input[name="SegmentId"]');
        const segmentActive = draggableForm.querySelector('input[name="SegmentShow"]');
        const segmentOrder = draggableForm.querySelector('input[name="SegmentOrder"]');
        const formData = [
            {
                referenceName: segmentName,
                id: segmentId?.value,
                referenceType: segmentReferenceName?.value || '',
                active: segmentActive?.checked,
                order: Number.parseInt(segmentOrder?.value || '0'),
            },
        ];
        try {
            const response = await fetch(endpoint, {
                method: method || 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                console.log('Show element form submitted successfully');
                setTimeout(() => {
                    spinner.classList.remove('spv-spinner--active');
                    spinner.classList.add('spv-spinner--done');
                }, 200);
                setTimeout(() => {
                    spinner.classList.remove('spv-spinner--done');
                }, 5000);
            }
            else {
                console.warn('Failed to submit show element form');
            }
        }
        catch (e) {
            console.error('Error submitting show element form: ', e);
        }
    }
}
export default function initReordableSectionForms() {
    document
        .querySelectorAll('.spv-draggable-container')
        .forEach(el => makeSectionReorderable(el.id));
}
document.addEventListener('DOMContentLoaded', () => {
    initReordableSectionForms();
});
//# sourceMappingURL=reorderable-section-form.js.map